import { Component, inject } from '@angular/core';
import { LocalityService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LocalityCreateDto,
  LocalityDto,
  LocalityExcelDownloadDto,
  LocalityUpdateDto,
} from '../proxy/planning/dtos/locality';
import { LOCALITY_CONFIG, LOCALITY_FIELDS } from './locality.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-locality',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LocalityService, ConfirmationService],
  templateUrl: './locality.html',
  styleUrl: './locality.scss',
})
export class Locality extends BaseHierarchicalCrudComponent<
  LocalityDto,
  LocalityCreateDto,
  LocalityUpdateDto,
  LocalityExcelDownloadDto
> {
  service = inject(LocalityService);
  config = LOCALITY_CONFIG;
  fields = LOCALITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: LocalityDto): LocalityUpdateDto {
    return {
      name: data.name,
      code: data.code,
      mtopCityId: data.mtopCityId,
      locationId: data.locationId,
      departmentId: data.departmentId,
      localityTypeId: data.localityTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Locality';
  }
}
